import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "bf-region-enrollment" }
const _hoisted_2 = {
  key: 0,
  class: ""
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-2x fa-spin fa-spinner" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "mb-1" }, "Du trainierst hier.", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Standort verlassen ")
const _hoisted_7 = { class: "fa fa-fw fa-spinner fa-spin" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "mb-1" }, "Du möchtest hier trainieren?", -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Standort beitreten ")
const _hoisted_10 = { class: "fa fa-fw fa-spinner fa-spin" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "mb-1" }, "Du möchtest hier trainieren?", -1)
const _hoisted_12 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : (_ctx.loggedIn)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.isEnrolled)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_5,
                  _createElementVNode("a", {
                    href: "#",
                    class: "btn btn-primary",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onPerformWithdrawal && _ctx.onPerformWithdrawal(...args)), ["prevent"]))
                  }, [
                    _hoisted_6,
                    _withDirectives(_createElementVNode("i", _hoisted_7, null, 512), [
                      [_vShow, _ctx.loadingWithdraw]
                    ])
                  ])
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_8,
                  _createElementVNode("a", {
                    href: "#",
                    class: "btn btn-primary",
                    onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onPerformEnrollment && _ctx.onPerformEnrollment(...args)), ["prevent"]))
                  }, [
                    _hoisted_9,
                    _withDirectives(_createElementVNode("i", _hoisted_10, null, 512), [
                      [_vShow, _ctx.loadingEnroll]
                    ])
                  ])
                ], 64))
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _hoisted_11,
            _createElementVNode("a", {
              href: _ctx.registerWithRegionPrefilledUrl,
              class: "btn btn-primary"
            }, "Für Standort registrieren", 8, _hoisted_12)
          ], 64))
  ]))
}